import React from "react";
import { Typography, Grid, Paper } from "@material-ui/core";
import useStyles from "../../styles/settingOptionStyle";
import { NavLink } from "react-router-dom";
import CustomImage from '@/components/Image'

const SettingOption = props => {
  const classes = useStyles();

  return (
    <Grid item xs={12} sm={6} md={3}>
      <Paper elevation={0} className={classes.paper}>
        <NavLink
          to={props.linkPath}
          className={classes.btn}
          onClick={props.clickBtn}
        >
          <div style={{display: "flex", justifyContent: "center"}}>
            {props.imgSrc && <CustomImage src={props.imgSrc} s3Path={props.imgS3Path} style={{"marginBottom": "21px" }} alt={props.imgAlt} />}
            {props.icon}
          </div>
          <Typography className={classes.wordBreak} variant="h6">
            {props.btnTitle}
          </Typography>
          <Typography
            className={classes.wordBreak}
            variant="body2"
            color="textSecondary"
          >
            {props.btnText}
          </Typography>
        </NavLink>
      </Paper>
    </Grid>
  );
};

export default SettingOption;
